var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "c-table-cell",
      attrs: { id: `violation-${_vm.data.violationDeadlineCell.id}` },
    },
    [
      _c("div", { staticClass: "c-table__cell-value" }, [
        _vm._v(" " + _vm._s(_vm.data.violationDeadlineCell.deadline) + " "),
        _vm.isFined
          ? _c(
              "a",
              {
                attrs: {
                  href: "/?r=redesign#/fines-and-bonuses",
                  target: "_blank",
                },
              },
              [_vm._v(" Штраф 100 ฿ ")]
            )
          : _vm._e(),
      ]),
      _vm.isFined
        ? _c(
            "b-popover",
            {
              attrs: {
                target: `violation-${_vm.data.violationDeadlineCell.id}`,
                triggers: "hover blur",
                placement: "bottom",
                container: "#app",
                "custom-class": "fine-tooltip",
              },
            },
            [
              _vm._v(
                " Выписан штраф за отсутствие объяснительной в размере 100 ฿ "
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }